import React from 'react';
import dayjs from 'dayjs';
import DataGrid from '../../../../common/DataGrid/DataGrid';
import { useTranslation } from 'react-i18next';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter';
import { renderPhdAbbreviatedValue } from '../utils/renderPhdAbbreviatedValue.jsx';

const PhdStudentsTable = ({
  students,
  onDetailClick,
  onDelete,
  pagination,
  onPaginationChange,
}) => {
  const { t } = useTranslation();

  const studentFilter = useDataGridTextFilter('student_display_name');
  const studyProgramFilter = useDataGridTextFilter('study_program_label');
  const departmentFilter = useDataGridTextFilter('department_label');
  const studyFormFilter = useDataGridTextFilter('study_form_label');
  const stateFilter = useDataGridTextFilter('state_label');
  const updatedByFilter = useDataGridTextFilter('updated_by_name');

  const translateStudyForm = (value) => {
    if (!value) return '—';
    return t(value);
  };

  const translateStudentState = (value) => {
    if (!value) return '—';
    return t(value);
  };

  const columns = [
    {
      title: t('Študent'),
      dataIndex: 'student_display_name',
      key: 'student_display_name',
      className: 'data-grid-column--full-text',
      minWidth: 240,
      ...studentFilter,
    },
    {
      title: t('Študijný odbor'),
      dataIndex: 'study_program_label',
      key: 'study_program_label',
      ellipsis: true,
      render: (value, row) =>
        renderPhdAbbreviatedValue(value, row.study_program_full_label),
      ...studyProgramFilter,
    },
    {
      title: t('Katedra'),
      dataIndex: 'department_label',
      key: 'department_label',
      ellipsis: true,
      render: (value, row) =>
        renderPhdAbbreviatedValue(value, row.department_full_label),
      ...departmentFilter,
    },
    {
      title: t('Forma štúdia'),
      dataIndex: 'study_form_label',
      key: 'study_form_label',
      ellipsis: true,
      ...studyFormFilter,
    },
    {
      title: t('Stav'),
      dataIndex: 'state_label',
      key: 'state_label',
      ellipsis: true,
      ...stateFilter,
    },
    {
      title: t('Naposledy upravené'),
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (value) =>
        value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '—',
    },
    {
      title: t('Upravil'),
      dataIndex: 'updated_by_name',
      key: 'updated_by_name',
      ellipsis: true,
      render: (value) => value || '—',
      ...updatedByFilter,
    },
  ];

  return (
    <DataGrid
      locale={{
        emptyText: t(
          'Pre zvolený pohľad a filtre nie sú dostupné žiadne záznamy.',
        ),
      }}
      rowKey={(row) => row.id}
      columns={columns}
      dataSource={(students || []).map((student) => ({
        ...student,
        study_form_label: translateStudyForm(student.study_form),
        state_label: translateStudentState(student.state),
      }))}
      permissionsBasic={'phd-students'}
      uniqueTableId={'phd-students-table'}
      onEditClick={onDetailClick}
      onRowClick={onDetailClick}
      onDelete={onDelete}
      secondaryCondition={(row) => row.can_edit !== false}
      deleteCondition={(row) => row.can_delete !== false}
      editDisabledTooltip={t('Archivovaný záznam je iba na čítanie')}
      deleteDisabledTooltip={t('Archivovaný záznam nie je možné vymazať')}
      scroll={{ x: 'max-content' }}
      pagination={pagination}
      onChange={onPaginationChange}
    />
  );
};

export default PhdStudentsTable;
